import { AvailableMenuItem } from '../../../../../providers/NavigationProvider/types';
import { BreadcrumbsItem } from '../BreadCrumb';

/**
 * This is stops an empty placeholder element that takes up space on the page when there should be
 * no breadcrumbs to display.
 */
export function shouldShowBreadcrumb(
  breadCrumbItems: BreadcrumbsItem[],
  menuItems?: AvailableMenuItem[],
): boolean {
  const hasMenuItems = menuItems && menuItems.length > 0;
  if (hasMenuItems) {
    return false;
  }

  const isBreadcrumbEmpty = !breadCrumbItems || breadCrumbItems.length === 0;
  if (isBreadcrumbEmpty) {
    return false;
  }

  const firstBreadcrumbIsSelected = breadCrumbItems[0].selected;
  const hasOnlyOneBreadcrumb = breadCrumbItems.length === 1;
  const hasOnlyASelectedBreadcrumb = hasOnlyOneBreadcrumb && firstBreadcrumbIsSelected;
  if (hasOnlyASelectedBreadcrumb) {
    return false;
  }

  return true;
}
